import React from 'react';
import { BiographyCardProps } from './types';
import './BiographySystem.css';

/**
 * BiographyCard - Unified content container for biography sections
 * Provides consistent styling and spacing for all biography content
 */
const BiographyCard: React.FC<BiographyCardProps> = ({
  children,
  className = '',
  variant = 'default',
  padding = 'md'
}) => {
  const cardClassName = [
    'biography-card',
    `biography-card--${variant}`,
    `biography-card--${padding}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClassName}>
      {children}
    </div>
  );
};

export default BiographyCard;